<div
  v-if="shouldRenderConfig"
  v-bind:class="getClassName"
>
  <div v-if="!getIsMobile" :class="getClassName + 'Content'">
    <div :class="getClassName + 'Main'">
      <div :class="getClassName + 'Pricing'">
        <div :class="getClassName + 'Quantity'">
          <span>{{$t('Quantity: ')}}</span>
          <span>{{ getFooterQuantity }}</span>
        </div>
        <div :class="getClassName + 'Cost'">
          <span>{{$t('Cost: ')}}</span>
          <span>{{ getSelectedQuantityFormattedBasePrice }}</span>
        </div>
      </div>
      <div :class="getClassName + 'Buttons'">
        <appQuotationButton></appQuotationButton>
        <appLoginButton></appLoginButton>
        <appAddToCartButton></appAddToCartButton>
      </div>
    </div>
    <div :class="getClassName + 'AdditionalInformation'">
      <div :class="getClassName + 'DeliveryInformationContainer'">
        <div>
          <span :class="getClassName + 'DespatchText'"> {{ getDespatchText }} </span>
        </div>
        <span>
          {{$t("VAT and delivery calculated at checkout")}}
        </span>
      </div>
      <div v-if="!getIsProductionSpeedHidden" :class="getClassName + 'ExpressCheckboxContainer'">
        <span :class="getClassName + 'ExpressText'">{{$t("Need it sooner? Tick here")}}</span>
        <input :class="getClassName + 'ExpressCheckbox'" v-on:click="handleClickExpressCheckbox($event)" type="checkbox"/>
      </div>
    </div>
  </div>
  <div v-else-if="getIsMobile && !getIsSummaryFooterExpanded" :class="getClassName + 'ContentMobile'">
    <div :class="getClassName + 'MinimizeArrowContainer'">
     <img v-on:click="setIsSummaryFooterExpanded(!getIsSummaryFooterExpanded)" :class="getClassName + 'MinimizeArrow'" :src="this.getBaseUrl + '/images/matrix/arrow_down.svg'"/>
     <!-- <span v-on:click="setIsSummaryFooterExpanded(!getIsSummaryFooterExpanded)" :class="getClassName + 'MinimizeArrow'">^</span> -->
    </div>
    <div :class="getClassName + 'MainMobile'">
      <div :class="getClassName + 'PricingMobile'">
        <div :class="getClassName + 'Quantity'">
          <span>{{$t('Quantity: ')}}</span>
          <span>{{ getFooterQuantity }}</span>
        </div>
        <div :class="getClassName + 'Cost'">
          <span>{{$t('Cost: ')}}</span>
          <span>{{ getSelectedQuantityFormattedBasePrice }}</span>
        </div>
      </div>
      <div :class="getClassName + 'ButtonsMobile'">
        <appQuotationButton></appQuotationButton>
        <appLoginButton></appLoginButton>
        <appAddToCartButton></appAddToCartButton>
      </div>
    </div>
  </div>
  <div v-else :class="getClassName + 'ContentMobile'">
      <div :class="getClassName + 'MinimizeArrowContainerExpanded'">
        <img v-on:click="setIsSummaryFooterExpanded(!getIsSummaryFooterExpanded)" :class="getClassName + 'MinimizeArrowExpanded'" :src="this.getBaseUrl + '/images/matrix/arrow_up.svg'"/>
        <!-- <span v-on:click="setIsSummaryFooterExpanded(!getIsSummaryFooterExpanded)" :class="getClassName + 'MinimizeArrowExpanded'">V</span> -->
      </div>
      <div :class="getClassName + 'PricingMobileExpanded'">
        <div :class="getClassName + 'Quantity'">
          <span>{{$t('Quantity: ')}}</span>
          <span>{{ getFooterQuantity }}</span>
        </div>
        <div :class="getClassName + 'Cost'">
          <span>{{$t('Cost: ')}}</span>
          <span>{{ getSelectedQuantityFormattedBasePrice }}</span>
        </div>
      </div>
      <div :class="getClassName + 'AdditionalInformationExpanded'">
        <div :class="getClassName + 'DeliveryInformationContainer'">
          <div>
            <span :class="getClassName + 'DespatchText'"> {{ getDespatchText }} </span>
          </div>
          <div v-if="!getIsProductionSpeedHidden" :class="getClassName + 'ExpressCheckboxContainer'">
            <span :class="getClassName + 'ExpressText'">{{$t("Need it sooner? Tick here")}}</span>
            <input :class="getClassName + 'ExpressCheckbox'" v-on:click="handleClickExpressCheckbox($event)" type="checkbox"/>
          </div>
          <div>
            {{$t("VAT and delivery calculated at checkout")}}
          </div>
        </div>
      </div>
      <div :class="getClassName + 'ButtonsMobileExpanded'">
        <appQuotationButton></appQuotationButton>
        <appLoginButton></appLoginButton>
        <appAddToCartButton></appAddToCartButton>
      </div>
  </div>
</div>
